import { Auth } from "domain/model/Auth"
import pn from "core/utils/pn"
import { postAPI } from "core/utils/axios"
import ProgressMeetingDataSource from "data/dataSource/Admin/ProgressMeetingDataSource"
import { Server } from "core/utils/axios"

const server = new Server()
import {
  API_CREATE_PROGRESS_MEETING,
  API_DELETE_PROGRESS_MEETING,
  API_GET_ALL_PROGRESS_MEETINGS,
  API_GET_UPCOMING_PROGRESS_MEETINGS,
  API_UPDATE_PROGRESS_MEETING,
  API_V4_ADMIN,
  API_V3_ADMIN,
  API_GET_PROGRESS_MEETING_FEEDBACK,
  API_GET_MENTORSHIP_STATS,
  API_GET_CLASS_STATS,
  API_GET_EXAMS_STATS,
} from "core/constants/strings"

export default class ProgressMeetingAPIDataSourceImpl implements ProgressMeetingDataSource {
  async createProgressMeeting(auth: Auth, data: any): Promise<any> {
    const id_token = auth?.id_token

    try {
      const response = await postAPI(pn(API_V4_ADMIN, API_CREATE_PROGRESS_MEETING), {
        id_token,
        data,
      })
      return response
    } catch (error) {
      return error
    }
  }

  async getAllProgressMeetings(auth: Auth, data: any): Promise<any> {
    const id_token = auth?.id_token

    try {
      const response = await postAPI(pn(API_V4_ADMIN, API_GET_ALL_PROGRESS_MEETINGS), {
        id_token,
        data,
      })
      return response
    } catch (error) {
      return error
    }
  }

  async getUpcomingProgressMeetings(auth: Auth, data: any): Promise<any> {
    const id_token = auth?.id_token

    try {
      const response = await postAPI(pn(API_V4_ADMIN, API_GET_UPCOMING_PROGRESS_MEETINGS), {
        id_token,
        data,
      })
      return response
    } catch (error) {
      return error
    }
  }

  async deleteProgressMeeting(auth: Auth, data: any): Promise<any> {
    const id_token = auth?.id_token

    try {
      const response = await postAPI(pn(API_V4_ADMIN, API_DELETE_PROGRESS_MEETING), {
        id_token,
        data,
      })
      return response
    } catch (error) {
      return error
    }
  }

  async updateProgressMeeting(auth: Auth, data: any): Promise<any> {
    const id_token = auth?.id_token

    try {
      const response = await postAPI(pn(API_V4_ADMIN, API_UPDATE_PROGRESS_MEETING), {
        id_token,
        data,
      })
      return response
    } catch (error) {
      return error
    }
  }

  async getProgressMeetFeedback(auth: Auth, meeting_id: string): Promise<any> {
    try {
      const response = await server.post(
        pn(API_V3_ADMIN, API_GET_PROGRESS_MEETING_FEEDBACK),
        { meeting_id },
        {
          Authorization: `Bearer ${auth?.id_token}`,
        }
      )

      return response?.data?.data
    } catch (error) {
      throw new Error(`Failed to fetch progress meets: ${error}`)
    }
  }

  async getMentorshipStats(auth: Auth, batches: string[], meetingDate: Number): Promise<any> {
    try {
      const response = await server.post(
        pn(API_V3_ADMIN, API_GET_MENTORSHIP_STATS),
        { batches, meetingDate },
        {
          Authorization: `Bearer ${auth?.id_token}`,
        }
      )

      return response?.data?.data
    } catch (error) {
      throw new Error(`Failed to fetch progress meets: ${error}`)
    }
  }

  async getClassAttendanceStats(auth: Auth, batches: string[], meetingDate: Number): Promise<any> {
    try {
      const response = await server.post(
        pn(API_V3_ADMIN, API_GET_CLASS_STATS),
        { batches, meetingDate },
        {
          Authorization: `Bearer ${auth?.id_token}`,
        }
      )

      return response?.data?.data
    } catch (error) {
      throw new Error(`Failed to fetch progress meets: ${error}`)
    }
  }
  async getExamStats(auth: Auth, batches: string[], meetingDate: Number): Promise<any> {
    try {
      const response = await server.post(
        pn(API_V3_ADMIN, API_GET_EXAMS_STATS),
        { batches, meetingDate },
        {
          Authorization: `Bearer ${auth?.id_token}`,
        }
      )

      return response?.data?.data
    } catch (error) {
      throw new Error(`Failed to fetch progress meets: ${error}`)
    }
  }
}
